(function () {
    if (/\/pages\/search-results-page\/?$/.test(location.pathname)) return;
    if (window.snizeDeferredLoaderInstalled || window.Searchanise?.Loaded) return;

    window.snizeDeferredLoaderInstalled = true;
    window.SearchaniseIncluded = true;

    let inputSelector = 'input[name=q]';
    let triggerSelector = '[data-js-laboo-open-search], input[name=q]';
    let triggerEvents = ['click', 'touchstart', 'focusin', 'input'];
    let loaderStarted = false;

    let startSearchanise = function (event) {
        if (!event.target.closest?.(triggerSelector) || loaderStarted) return;

        loaderStarted = true;

        let initScript = document.createElement('script');
        initScript.id = 'snize_init';
        initScript.src = 'https://searchanise-ef84.kxcdn.com/widgets/shopify/init.js?a=9X0Q9b5q3y';
        initScript.async = true;
        initScript.onerror = function () {
            if (window.Searchanise) return;
            initScript.remove();
            window.SearchaniseIncluded = true;
            loaderStarted = false;
        };

        window.SearchaniseIncluded = false;
        document.head.appendChild(initScript);
    };

    triggerEvents.forEach(function (eventName) {
        document.addEventListener(eventName, startSearchanise, { capture: true, passive: true });
    });

    document.addEventListener('submit', function (event) {
        let searchInput = event.target.querySelector?.(inputSelector);
        if (!searchInput || window.Searchanise?.Loaded) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        location.assign((window.Shopify.routes?.root || '/') + 'pages/search-results-page?q=' + encodeURIComponent(searchInput.value));
    }, true);

    document.addEventListener('Searchanise.Loaded', function () {
        (function ($) {
            triggerEvents.forEach(function (eventName) {
                document.removeEventListener(eventName, startSearchanise, true);
            });

            let readinessDeadline = Date.now() + 120000;
            let readinessTimer = setInterval(function () {
                let activeInput = document.activeElement;
                if (!activeInput?.matches(inputSelector) || Date.now() >= readinessDeadline) {
                    clearInterval(readinessTimer);
                    return;
                }

                let searchInput = $(activeInput);
                let autocompleteInstance = searchInput.data('autocompleter');
                if (!autocompleteInstance) return;

                clearInterval(readinessTimer);
                searchInput.triggerHandler('focus');
                searchInput.triggerHandler(autocompleteInstance.select.isMobileMode() ? 'mousedown' : 'click');
                if (activeInput.value) searchInput.triggerHandler('keyup');
            }, 100);
        })(window.Searchanise.$);
    }, { once: true });
})();
